<template lang="html">


    <div class="cover-popup row-center">
        <div class="popup">
            <h2 class="title-pop">¡Recuerda!</h2>
            <p>Antes de inscribirte, asegúrate de que:</p>

            <ul>
                <li>Los datos de tu perfil están actualizados y has adjuntado tu CV personal en el apartado
                    "Documentación" de tu perfil. <router-link :to="$t('enlaces.micv')">Compruébalo aquí</router-link>.</li>
                <li>Cumples con los requisitos mínimos de esta oferta. De hacerles llegar candidaturas que no se adecúan
                    al perfil demandado, las empresas pueden dejar de confiar en ESIC para gestionar sus procesos de
                    selección. Inscribirte en ofertas que no se ajustan a tu perfil puede hacernos perder la oferta de
                    tus sueños, esa para la que encajas a la perfección.</li>
            </ul>

            <div class="contenedor-botones row-center">
                <button class="btn" @click="send" :loading="loading">Inscribirme</button>
                <button class="btn skull" @click="$emit('hide')">Cancelar</button>
            </div>

        </div>

    </div>

</template>

<script lang="js">

    import { mapActions } from 'vuex';

    export default {
        name: 'popup-inscripcion',
        data() {
            return {
                loading: false
            }
        },
        methods: {
            ...mapActions(['inscripcionOferta']),
            send() {
                this.loading = true;
                this.inscripcionOferta(this.$route.params.id).then(r => {
                    if (r) {
                        this.setInscrito();
                    }else{
                        this.$emit('hide');
                    }
                    this.loading = false;
                }).catch(e => { })
            },
            setInscrito() {
                this.$emit("inscrito");
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '@/assets/css/colors.scss';

    .cover-popup .popup {
        .title-pop {
            text-transform: capitalize;
            text-align: center;
        }

        p {
            text-align: center;
            margin-bottom: 30px;
            font-size: 14px;
        }

        ul {
            margin-bottom: 30px;
        }

        li {
            margin-bottom: 20px;

            a {
                color: $blue;
                font-family: "Conv_KelsonSans-Bold";
            }
        }

        .btn {
            margin: 0 15px;
        }
    }

    @media screen and (max-width: 440px) {
        .cover-popup .popup {
            .btn:first-of-type {
                margin-bottom: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-inscripcion.vue